import * as Styles from './styles'
import Icon from '../../icon'
import React from 'react'

type Props = {
  active?: boolean
  disabled?: boolean
  handleEvent: () => void
  icon?: string
  notification?: boolean
  svg?: object
  text: string
  visible?: boolean
  style?: object
}

const Item: React.FC<Props> = (props: Props) => {
  const activeTheme = `${props.active ? 'is-active' : ''}`
  const disabledTheme = `${props.disabled ? 'is-disabled' : ''}`

  return (
    <Styles.Item
      notification={props.notification}
      className={activeTheme}
      onClick={() => !props.disabled && props.handleEvent()}
    >
      <Styles.Button disabled={props.disabled}>
        {props.notification && !props.active && <Styles.WrapperNotification />}

        <Styles.Icon className={disabledTheme}>
          <Icon name={props?.icon} svg={props?.svg} />
        </Styles.Icon>

        <Styles.Text className={disabledTheme}>{props.text}</Styles.Text>
      </Styles.Button>
    </Styles.Item>
  )
}

Item.defaultProps = {
  active: false,
  notification: false,
  disabled: false,
}

export default Item
